import { FormControl } from '@material-ui/core'
import ChatIcon from '@material-ui/icons/Chat'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDownRounded'
import { Button, Menu, MenuItem } from '@mui/material'
import _, { isEmpty } from 'lodash'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import {
  apiEndpoints,
  fetchTransactionData,
  fetchEnrolment,
  fetchUser,
  membershipActions,
  fetchProgramEnrolments,
  updateTicket,
  updateInteraction
} from 'api'
// Aliased: imported as `Error` it shadowed the global, so every
// `throw new Error(...)` in this file threw "is not a constructor" (an arrow
// component can't be new'd) and the save-blocking messages never reached the
// alert.
import { Error as ErrorState } from 'app/components/Error'
import { AutoComplete } from 'app/components/generic/FormFields'
import History from 'app/components/generic/history/history'
import { Loading } from 'app/components/generic/LottieComponents'
import Slider from 'app/components/generic/Slider/slider'
import ModalForm from 'app/components/ModalForm'
import {
  navigationPaths,
  nonMemberActions,
  parentActions,
  superAdminWalletActions
} from 'app/config'
import constants, {
  FORCE_UPDATE_ERROR_MESSAGE,
  USER_EXISTS_ERROR_MESSAGE
} from 'app/constants'
import {
  alertDialog,
  confirm,
  eventAlert,
  eventEmitter,
  makeRequestUrl
} from 'app/helpers'
import { useAccess } from 'app/hooks/useAccess'
import { batchTypesMap } from 'app/pages/Class/Inventory/constants'
import {
  getMissingTemplateFields,
  INTERACTION_TEMPLATES,
  INTERACTION_TEMPLATE_VALIDATE,
  requiredFollowUpDateProblem
} from 'app/pages/Communication/InteractionHistory/templates'
import GuardiansPanel from 'app/pages/User/Parent/components/GuardiansPanel'
import { parentDataTransformer } from 'app/transformer'

import { FamilyBlock } from './components/FamilyBlock'
import MasterModal from './components/MasterModal'
import { MembershipBlock } from './components/MembershipBlock'
import { StudentHistoryDrawer } from './components/StudentHistoryDrawer'
import { SummaryBlock } from './components/SummaryBlock'
import { blocks, dataColumns } from './config'
import {
  getEnrolmentData,
  getIcon,
  getRatingSessions,
  getWalletData,
  getScheduleSuggestion,
  getEnrolmentExtensions,
  fetchAttendanceData,
  fetchLifeTimeAttendanceData,
  getInteractionsData,
  getTicketsData,
  getAppData
} from './helpers'
import * as styles from './styles'

import { ParentDetails } from '../../../components/shared/ParentDetails'
import MasterForm from '../../User/Parent/MasterForm'

const ParentDashboard = () => {
  const [loading, setLoading] = React.useState(true)
  const [selectedParentDetails, setSelectedParentDetails] = React.useState({})
  const [enrolmentData, setEnrolmentData] = useState({})
  const [summaryData, setSummaryData] = useState(blocks)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const [isFormOpen, setIsFormOpen] = React.useState(false)
  const [modalData, setModalData] = React.useState({})
  const [action, setAction] = React.useState('')
  const [refresh, setRefresh] = React.useState(false)
  const [error, setError] = React.useState(null)
  const [profileDetailsModalOpen, setProfileDetailsModalOpen] =
    React.useState(false)
  const [parentsDetails, setParentDetails] = React.useState([])
  // Student-history drawer: opens when a child is clicked on the Family card,
  // shows tabs for Enrolments / Payments / Attendance scoped to that student.
  const [historyStudent, setHistoryStudent] = React.useState(null)
  const [extraFormData, setExtraFormData] = React.useState({})
  const { isSuperAdmin } = useAccess()
  let globalSummaryData = summaryData

  const openModal = React.useCallback((e, action) => {
    e.preventDefault()
    setIsModalOpen(true)
    setAction(action)
  }, [])

  const closeModal = () => {
    setIsModalOpen(false)
  }

  const openForm = React.useCallback((e, action, data) => {
    if (e) {
      e.preventDefault()
    }
    setIsFormOpen(true)
    setAction(action)
    setExtraFormData(data)
  }, [])

  const closeForm = () => {
    setIsFormOpen(false)
  }

  const onActionButtonClick = async (e, action, data) => {
    handleClose()
    openForm(e, action, data)
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const slackNotificationTrigger = (action, data) => {
    onActionButtonClick(null, action, data)
  }

  const openModalForm = (data) => {
    const { event, action, actionData } = data
    openForm(event, action, actionData)
  }

  const onSaveClick = async (newData, action) => {
    try {
      const formData = { ...newData, ...extraFormData }
      let res
      if (action === 'edit_interaction') {
        // Same completeness rules the Interaction History page enforces in its
        // beforeSaveFunction — kept here because MasterForm has no equivalent
        // hook. Throwing lands in the catch below, which alerts and re-enables
        // the modal's SAVE button.
        if (newData?.connected_status === 'Connected') {
          const missing = []
          ;(newData.interaction_topics || []).forEach((row) => {
            const template = INTERACTION_TEMPLATES[row?.topic]
            if (!template) return
            missing.push(
              ...getMissingTemplateFields(template, row?.structured_data || {})
            )
          })
          if (!isEmpty(missing)) {
            // Turn the blank fields red in every rendered template.
            eventEmitter.emit(INTERACTION_TEMPLATE_VALIDATE)
            throw new Error(
              `Please fill these mandatory fields before saving: ${missing.join(
                ', '
              )}.`
            )
          }
        }
        // Recharge "Will recharge" = Yes / Undecided needs a real follow-up
        // date (user 2026-09-24) — checked first, as the messages below offer
        // "No", which that answer rules out.
        const followUpDateProblem = requiredFollowUpDateProblem(newData)
        if (followUpDateProblem) throw new Error(followUpDateProblem)
        if (['Connected', 'DNP'].includes(newData?.connected_status)) {
          // '' = unanswered, 'yes' = answered but no date picked yet.
          if (
            newData?.follow_up_date === '' ||
            newData?.follow_up_date === undefined
          ) {
            throw new Error('Please answer whether a follow-up is required.')
          }
          if (newData?.follow_up_date === 'yes') {
            throw new Error(
              'Please choose a follow-up date, or select "No" for follow-up.'
            )
          }
        }
        const isConnected = newData.connected_status === 'Connected'
        res = await updateInteraction(newData.interaction_uuid, {
          interaction_date: newData.interaction_date,
          connected_status: newData.connected_status,
          // The channel only exists for a Connected interaction; sending the
          // stale value of a row switched to DNP would keep what the form no
          // longer shows.
          interaction_mode: isConnected ? newData.interaction_mode : null,
          // The topic is asked on every outcome now (user 2026-09-24), so a
          // non-Connected edit keeps it. Its summary / template answers are
          // Connected-only and hidden, so they are dropped rather than kept
          // stale, and the topic stands in for the NOT NULL summary — the
          // Grow & Retain drawer's fallback for a DNP.
          interaction_topics: isConnected
            ? newData.interaction_topics
            : (newData.interaction_topics || [])
                .filter((row) => row?.topic)
                .map((row) => ({
                  topic: row.topic,
                  summary: row.topic,
                  structured_data: null
                })),
          follow_up_date: newData.follow_up_date
        })
      } else if (action === 'edit_ticket_status') {
        res = await updateTicket({
          user: formData.uuid,
          status: newData.status,
          resolution_summary: newData.resolution_summary,
          resolution_conclusion: newData.resolution_conclusion,
          uuid: formData.ticketId,
          follow_up_date: newData?.follow_up_date,
          conversion_intent: newData?.conversion_intent,
          interested_programs: newData?.interested_programs?.map(
            (item) => item.value
          ),
          tentative_joining_date: newData?.tentative_joining_date?.value,
          intent_reason: newData?.intent_reason
        })
      } else res = await membershipActions(formData, action)

      // E-mandate setup produces a link that has to reach the parent. The backend already
      // WhatsApps it and parks it on the invoice, but the person who clicked is usually on a
      // call with the parent — so hand it straight over, copied and readable, instead of the
      // generic "Done".
      if (action === 'setup_emandate' && res?.success) {
        const link = res?.data?.short_url || res?.data?.payment_link
        const cap = res?.data?.max_amount
        if (link && navigator.clipboard) {
          try {
            await navigator.clipboard.writeText(link)
          } catch (copyError) {
            console.log('clipboard unavailable', copyError)
          }
        }
        alertDialog({
          icon: 'success',
          title: 'e-Mandate link created',
          text: [
            cap
              ? `Limit authorised: ₹${Number(cap / 100).toLocaleString(
                  'en-IN'
                )}.`
              : '',
            res?.data?.delivery?.whatsapp_sent
              ? 'Sent to the parent on WhatsApp.'
              : 'WhatsApp could not be sent — share the link manually.',
            link ? `Link (copied): ${link}` : '',
            'Nothing has been charged. Auto-pay goes live once the bank confirms.'
          ]
            .filter(Boolean)
            .join('\n')
        })
      }

      if (
        res?.success ||
        res?.subscription?.uuid ||
        res?.uuid ||
        res?.user_id ||
        res?.title
      ) {
        eventEmitter.emit(constants.CLOSE_MODAL_FORM)
        eventAlert('Done', constants.SUCCESS)
        closeForm()
        let search = selectedParentDetails.uuid
        if (res?.subscription?.uuid) {
          search = res?.subscription?.user?.phone
        } else if (res?.data) {
          search = res?.data?.user
        } else if (res?.success || res?.uuid || res?.title) {
          search = selectedParentDetails?.uuid
        }
        const parent = await fetchParentDetails(search)
        if (!isEmpty(parent)) handleParentSelection(null, parent[0])
        setTimeout(() => {
          setRefresh((prevstate) => !prevstate)
        }, 200)
      }
    } catch (error) {
      const errorType = error.message.split('-')[0]
      const errorMessage = error.message.split('-')[1]
      console.log(error)
      if (errorType === 'error_user_exists') {
        setExtraFormData(newData)
        confirm(
          async () =>
            await onSaveClick(
              { ...newData, force_update_number: true },
              'change_phone_number'
            ),
          USER_EXISTS_ERROR_MESSAGE,
          () => {
            return
          }
        )
      } else if (errorType === 'error_force_delete_user') {
        closeForm()
        confirm(
          () =>
            slackNotificationTrigger('parent_number_deletion_request', {
              errorMessage,
              newPhoneNumber: newData?.new_phone_number
            }),
          FORCE_UPDATE_ERROR_MESSAGE,
          () => {
            return
          }
        )
      } else {
        eventAlert(error.message, constants.ERROR)
      }
      eventEmitter.emit(constants.MODAL_FORM_SAVE_ERROR, error)
    }
  }

  const setData = (type, data) => {
    const icon = getIcon(type)
    const tempSummaryData = [...globalSummaryData]
    const currentIndex = tempSummaryData.findIndex((el) => el.type === type)

    if (currentIndex !== -1) {
      if (tempSummaryData[currentIndex].type === type) {
        tempSummaryData[currentIndex].data = data
        tempSummaryData[currentIndex].icon = icon
        globalSummaryData = tempSummaryData
        return setSummaryData(tempSummaryData)
      }
    } else {
      let newData = {
        type: type,
        data: data,
        icon: icon
      }
      //Adding the card to the second last index to keep the interactions block at the end
      tempSummaryData.splice(tempSummaryData.length - 1, 0, newData)
      globalSummaryData = tempSummaryData

      return setSummaryData(tempSummaryData)
    }
  }

  const profileButtonOnclickHandler = () => {
    setProfileDetailsModalOpen(true)
  }

  const closeProfileDetailsModal = () => {
    setProfileDetailsModalOpen(false)
  }

  useEffect(() => {
    ;(async () => {
      if (selectedParentDetails?.phone_number) {
        const enrolmentUrl = makeRequestUrl(apiEndpoints.fetchEnrolment, {
          no_page: 'True',
          exclude_type: 'make_up_session',
          batch_type_ne: `${batchTypesMap.exploration},${batchTypesMap.exploration_camp}`,
          parent_phone_number: selectedParentDetails?.phone_number,
          limit: 100
        })

        // Promise.allSettled so a single failing call doesn't reject the
        // whole batch — previously this surfaced as "Uncaught (in promise)",
        // which pops the CRA dev-mode error overlay and blocks every click
        // on the page. Each result is unwrapped defensively. Most common
        // failure here is a 400 from the backend when the Course schema
        // drifts (e.g. missing level_id column on staging); we still want
        // the page to render whatever data we did get.
        const [enrolmentsRes, programEnrolmentsRes] = await Promise.allSettled([
          fetchEnrolment({ url: enrolmentUrl }),
          fetchProgramEnrolments({
            url: null,
            queries: { parent: selectedParentDetails.uuid }
          })
        ])

        const enrolments =
          enrolmentsRes.status === 'fulfilled' ? enrolmentsRes.value : null
        const programEnrolments =
          programEnrolmentsRes.status === 'fulfilled'
            ? programEnrolmentsRes.value
            : null

        const explorationProgramEnrolments =
          programEnrolments?.results?.filter(
            (el) => el?.program?.type === 'exploration'
          ) || []

        const finalEnrolmentsData = [
          ...(enrolments?.results || []),
          ...explorationProgramEnrolments
        ].sort((a, b) => new Date(b.start_date) - new Date(a.start_date))
        setEnrolmentData({ data: finalEnrolmentsData })
      }
    })().catch((err) => {
      // Belt-and-suspenders for any sync throw inside the IIFE — never
      // leave the page in a frozen "Uncaught (in promise)" state.
      // eslint-disable-next-line no-console
      console.error('ParentDashboard enrolment fetch failed:', err)
      setEnrolmentData({ data: [] })
    })
  }, [selectedParentDetails?.phone_number])

  useEffect(() => {
    ;(async () => {
      if (selectedParentDetails.uuid && enrolmentData?.data?.length >= 0) {
        if (enrolmentData?.data?.length > 0) {
          const data = getEnrolmentData(enrolmentData, openModal, setModalData)
          setData('enrolments', data)
          // setData('engagement', data)
          const attendanceData = await fetchAttendanceData(
            selectedParentDetails.uuid
          )
          setData('monthly attendance', { ...attendanceData, ...data })
          // const ratingResult = await getRatingSessions(
          //   selectedParentDetails.uuid,
          //   null,
          //   openModal,
          //   setModalData,
          //   data
          // )

          // setData('classroom experience', ratingResult)
          const lifetimeAttendance = await fetchLifeTimeAttendanceData(
            selectedParentDetails.uuid
          )
          setData('lifetime health', lifetimeAttendance)
          // // const extensionData = await getEnrolmentExtensions(
          //   selectedParentDetails.uuid,
          //   data
          // )
          // setData('enrolments extension', extensionData)
        } else {
          setData('enrolments', [])
          setData('monthly attendance', [])
          // setData('engagement', [])
          // setData('enrolments extension', {})
        }

        const res = await fetchTransactionData({
          parent: selectedParentDetails.uuid
        })
        const dataResult = getWalletData(res, openModal)
        setData('wallet', dataResult)
      } else {
        setData('wallet', [])
      }
      // The autopay card fetches its own mandate; this call only stamps the card's
      // icon, which setData owns for every block.
      setData('e-mandate', [])
    })()
  }, [selectedParentDetails.uuid, enrolmentData])

  useEffect(() => {
    ;(async () => {
      if (selectedParentDetails.uuid) {
        // Journey box removed from dashboard (2026-05-14) — the FSM rework
        // is moving Journey out of student_progress, and the box was being
        // flagged as unused. Fetch + setData call removed alongside it.

        // Fetch app data for the parent (single API call for both cards).
        const appData = await getAppData(selectedParentDetails?.uuid)
        setData('app version', appData?.appVersion)
        setData('moments', appData?.momentData)

        // const scheduleSuggestions = await getScheduleSuggestion(
        //   selectedParentDetails.uuid
        // )
        // if (scheduleSuggestions.length)
        //   setData('Schedule Suggestion', scheduleSuggestions)

        const ticketsData = await getTicketsData(
          selectedParentDetails.phone_number,
          openModalForm
        )
        setData('tickets log', ticketsData)

        const interactionData = await getInteractionsData(
          selectedParentDetails.phone_number,
          openModalForm
        )
        setData('interactions', interactionData)
      }
    })()
  }, [selectedParentDetails.uuid, refresh])

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const blockType = params.get('type')
    const key = params.get('key')
    const value = params.get('value')
    if (params.get('openSlider') === 'true' && selectedParentDetails.uuid) {
      const emitData = {
        blockOpenType: blockType,
        key,
        value
      }
      eventEmitter.emit(constants.SLIDER_OPENER, emitData)
    }

    {
      ;(async () => {
        const parentData = await parentDataTransformer(selectedParentDetails)
        setParentDetails(parentData)
      })()
    }
  }, [selectedParentDetails.uuid])

  const fetchParentDetails = async (searchedText) => {
    setError(null)
    searchedText = searchedText.trim()

    try {
      var numberReg = /^\d+$/
      var aplhaReg = /^[a-zA-Z ]*$/
      var uuidReg =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/

      if (searchedText?.length >= 0) {
        let queries = {}

        if (numberReg.test(searchedText))
          queries = { phone_number: searchedText }
        else if (aplhaReg.test(searchedText)) queries = { name: searchedText }
        else if (uuidReg.test(searchedText)) queries = { uuid: searchedText }

        const response = await fetchUser({ queries }, constants.PARENT)

        if (response.results.length > 0) {
          // Multi-guardian: expand each family into N dropdown rows — one per
          // active guardian. Each row's label shows that guardian's info, but
          // all rows for a family share the same `value` (parent UUID) so
          // clicking any of them opens the same family profile. Falls back to
          // one row per family if the response has no `guardians` array
          // (legacy data, backfill not run, or non-multi-guardian endpoint).
          return response.results.flatMap((item) => {
            const {
              uuid,
              first_name,
              last_name,
              phone_number,
              active_subscription,
              credits,
              member_status,
              address_detail,
              state
            } = item?.user

            const {
              centre_preference,
              students,
              user,
              additional_information,
              customer_start_date,
              is_policy_acknowledged_alfred,
              crm = {},
              guardians = []
            } = item

            user.full_name = `${first_name} ${last_name}`

            setLoading(false)

            const baseOption = {
              uuid,
              value: uuid,
              first_name,
              last_name,
              phone_number,
              students: students,
              guardians: guardians,
              centre: centre_preference,
              active_subscription: active_subscription,
              user,
              credits: credits,
              member_status,
              address_detail,
              state,
              additional_information,
              customer_start_date,
              is_policy_acknowledged_alfred,
              crm_flags: crm?.flags ?? [],
              crm_tags: crm?.tags ?? []
            }

            // Always one option per family, labelled with the PARENT's
            // (primary account holder's) number + name — even when the search
            // matched a guardian's phone. The matched guardian's details still
            // render inside the FamilyBlock after selection (`guardians` is kept
            // on the option for that), so this keeps the parent directory keyed
            // on the parent, not on whichever family member you searched by.
            return [
              {
                ...baseOption,
                name: `${phone_number} (${first_name} ${last_name})`
              }
            ]
          })
        } else if (response.results.length > 1 && searchedText.length === 10) {
          throw new Error('Multiple user found with same number')
        } else if (response.results.length === 0) {
          setError('Parent Not Found')
          return []
        } else {
          return []
        }
      }
    } catch (error) {
      setLoading(false)
      console.log('Error in fetching user :- ', error)
      throw error
    }
  }

  const handleParentSelection = (name, value) => {
    // Children are rendered inside the FamilyBlock now — no separate
    // children summary card. (Removed setData('children', value?.students)
    // because setData auto-injects unknown types, which kept resurrecting
    // the standalone Children card.)
    setSelectedParentDetails(value || {})
    localStorage.setItem('parent', JSON.stringify(value || {}))
  }
  const formElement = React.useMemo(() => {
    const prevParent = JSON.parse(localStorage.getItem('parent'))
    const searchText = new URLSearchParams(window.location.search)?.get(
      'parent'
    )
    return (
      <FormControl variant="outlined" fullWidth required={true}>
        <AutoComplete
          async={true}
          name={'user'}
          label="Search family by parent, guardian, name, or number"
          multiple={false}
          fetchValues={fetchParentDetails}
          onChange={handleParentSelection}
          initialSelectIndex={0}
          selectOnFocus={true}
          searchText={
            searchText ? searchText : prevParent?.uuid ? prevParent?.uuid : ''
          }
          size="small"
          fetchOnMount
        />
      </FormControl>
    )
  }, [refresh])

  const buttonElement = React.useMemo(() => {
    const status = selectedParentDetails?.user?.member_status
    const baseActions = status ? parentActions : nonMemberActions
    // Non-members have no Deduct, so anchor on Add coins there.
    const coinActionKey = 'deduct' in baseActions ? 'deduct' : 'topup'
    const dashBoardActions = isSuperAdmin
      ? Object.fromEntries(
          Object.entries(baseActions).flatMap((entry) =>
            entry[0] === coinActionKey
              ? [entry, ...Object.entries(superAdminWalletActions)]
              : [entry]
          )
        )
      : baseActions

    return (
      <styles.ButtonWrapper>
        <Button
          id={'Button' + selectedParentDetails?.active_subscription?.uuid}
          aria-controls={open ? 'demo-customized-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          variant="contained"
          onClick={profileButtonOnclickHandler}
          className="button-dashboard"
        >
          view profile details
        </Button>

        <Button
          id={'Button' + selectedParentDetails?.active_subscription?.uuid}
          aria-controls={open ? 'demo-customized-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          variant="contained"
          onClick={handleClick}
          endIcon={<KeyboardArrowDownIcon />}
          className="button-dashboard"
        >
          Actions
        </Button>

        {/* <Button
          variant="contained"
          startIcon={<ChatIcon />}
          className="button-dashboard"
          component={Link}
          to={navigationPaths.centreParentChat}>
          chat with parent
        </Button> */}

        <Menu
          id={'Menu' + selectedParentDetails?.active_subscription?.uuid}
          MenuListProps={{
            'aria-labelledby': 'demo-customized-button'
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          {Object.keys(dashBoardActions)
            .filter((el) =>
              el === 'extend' && status === 'due' ? false : true
            )
            .map((action, index) => {
              return (
                <MenuItem
                  onClick={(e) => {
                    onActionButtonClick(e, action)
                  }}
                  disableRipple
                  key={index}
                >
                  {dashBoardActions[action]}
                </MenuItem>
              )
            })}
        </Menu>
      </styles.ButtonWrapper>
    )
  }, [selectedParentDetails, open, isSuperAdmin])

  return (
    <styles.Container>
      <styles.Header>
        <styles.Dropdown>{formElement}</styles.Dropdown>
        {buttonElement}
      </styles.Header>
      {error ? (
        <ErrorState error={error} />
      ) : loading ? (
        <Loading />
      ) : (
        <styles.Widgets>
          <MembershipBlock selectedParentDetails={selectedParentDetails} />
          <FamilyBlock
            selectedParentDetails={selectedParentDetails}
            onChildClick={(s) => setHistoryStudent(s)}
          />

          {summaryData?.map((data, index) => {
            if (data.slider) {
              return (
                <Slider
                  width="50%"
                  key={'Slide' + index}
                  fullWidth={data.fullWidth || false}
                  placeholder={
                    <SummaryBlock
                      keyIndex={'Summary' + index}
                      selectedParentDetails={selectedParentDetails}
                      summaryData={data}
                      enrolmentData={enrolmentData}
                    />
                  }
                  blockType={data.type}
                  childComponent={
                    <History
                      openModalForm={openModalForm}
                      selectedParentDetails={selectedParentDetails}
                      type={dataColumns[data.type]?.type}
                      heading={dataColumns[data.type]?.heading}
                      userInfo={selectedParentDetails?.user}
                      data={data.data}
                      tableHeadings={dataColumns[data.type]?.tableHeadings}
                      accessors={dataColumns[data.type]?.accessors}
                      readOnly={true}
                      editableDetails={false}
                      addDetails={false}
                      headerData={data.headerData}
                    />
                  }
                />
              )
            } else if (data?.link) {
              return (
                <Link
                  key={'Link' + index}
                  to={makeRequestUrl(`${data?.link}`, data?.data?.queryParams)}
                  onClick={(e) => {
                    if (!data?.data?.isClickable) {
                      // Condition when the link should be disabled
                      e.preventDefault()
                    }
                  }}
                  style={{
                    cursor: data?.data?.isClickable ? 'pointer' : 'default',
                    textDecoration: 'none',
                    color: 'inherit',
                    fontWeight: 'normal'
                  }}
                >
                  <SummaryBlock
                    key={'Slide' + index}
                    keyIndex={'Summary' + index}
                    selectedParentDetails={selectedParentDetails}
                    summaryData={data}
                  />
                </Link>
              )
            } else {
              return (
                <SummaryBlock
                  key={'Slide' + index}
                  keyIndex={'Summary' + index}
                  fullWidth={data.fullWidth || false}
                  selectedParentDetails={selectedParentDetails}
                  summaryData={data}
                  enrolmentData={enrolmentData}
                />
              )
            }
          })}
        </styles.Widgets>
      )}
      {/* StudentHistoryDrawer => per-child enrolments / attendance */}
      <StudentHistoryDrawer
        open={Boolean(historyStudent)}
        onClose={() => setHistoryStudent(null)}
        student={historyStudent}
      />

      {/* MasterForm => all parent action forms */}
      <MasterForm
        isModalOpen={isFormOpen}
        onSaveClick={onSaveClick}
        closeModal={closeForm}
        action={action}
        data={selectedParentDetails}
        extraFormData={extraFormData}
      />

      {/* MasterModal => all modal grid data */}
      <MasterModal
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        action={action}
        data={modalData || {}}
        parentData={selectedParentDetails}
        enrolmentData={enrolmentData}
      />

      {/* ModalForm => parent details modal*/}
      <ModalForm
        isModalOpen={profileDetailsModalOpen}
        onModalClose={closeProfileDetailsModal}
        enableSave={false}
      >
        <ParentDetails parentDetails={parentsDetails} />
        {/* Multi-guardian: same panel as the Parent listing page so admins
            can manage family members from either entry point. */}
        {selectedParentDetails?.uuid ? (
          <div style={{ marginTop: 24 }}>
            <GuardiansPanel parentUuid={selectedParentDetails.uuid} />
          </div>
        ) : null}
      </ModalForm>
    </styles.Container>
  )
}

export default ParentDashboard
